export default {
  mission: {
    eyebrow: 'Who We Are',
    title: '経営理念',
    vision: {
      title: 'ビジョン',
      subtitle: '私たちがつくりたい世界',
      label: 'ビジョン',
      text: '世界中の人が相互理解を深める透明でフェアな社会',
      imgAlt: 'ビジョン — 日本と世界をつなぐ',
    },
    mission: {
      title: 'ミッション',
      subtitle: 'ビジョンを実現するために私たちがやること',
      label: 'ミッション',
      text: '人材を育成し、日本と世界の市場をつなぐ。',
      imgAlt: '私たちのミッション — 日本と世界をつなぐ人材育成',
    },
    values: {
      title: 'バリュー',
      subtitle: 'ミッションを実行するときに私たちが守る行動基準',
      imgAlt: '私たちのコアバリュー',
      list: [
        { number: '01', title: 'Customer First', description: '顧客の問題解決からすべてが始まる' },
        { number: '02', title: 'Speed Matters', description: 'スピードの重要性を浸透させる' },
        { number: '03', title: 'Leadership & Ownership', description: 'オーナーシップとリーダーシップを持つ' },
        { number: '04', title: 'Ethical Innovation', description: '知恵とテクノロジーでイノベーションを起こす' },
        { number: '05', title: 'Strength & Kindness', description: '強さと優しさを兼ね備える' },
        { number: '06', title: 'Clear Communication', description: 'オープンで明快なコミュニケーション' },
      ],
    },
  },
};
